module.exports = __webpack_public_path__ + "static/media/rsa.cacc2ca1.svg";